module.exports = __webpack_public_path__ + "static/media/wall.c10390fd.png";